<template>
  <div class="tw-whitespace-nowrap">{{ originatingCompany || '' }}</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const TrustedContactOriginatingCompanyColumn = graphql(`
  fragment TrustedContactOriginatingCompanyColumn on TrustedContact {
    id
    company {
      id
      name
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof TrustedContactOriginatingCompanyColumn> }>()
const column = computed(() => useFragment(TrustedContactOriginatingCompanyColumn, props.row))
const originatingCompany = computed(() => column.value.company?.name ?? null)
</script>

<style scoped></style>
